module.exports = __webpack_public_path__ + "static/media/nature_img.63dc09e7.jpg";